import {
  uxGender,
  uxRoute,
  uxRouteQuestionOnly,
  uxRouteQuestionPushScan,
  uxRouteNone,
  uxRouteDefault,
  uxConsentScreen,
  uxHideConsentTitle,
  uxFitFeedbacks,
  uxForceDesktopLayout,
  font,
  titleStyles,
  subtitlesStyles,
  ctaStyles,
  policityStyles,
  scanCTAStyle,
  welcomeScreenUI,
  unitsRight,
  unitsFontFamily,
  unitsInactiveFontWeight,
  inputDesktopWidthOffset,
  choiceScreenUI,
  bodyScanScreenUI,
  femaleBraScreenUI,
  morphoUIStyles,
  resultScreenUI,
  activeStylesContinue,
  disabledStylesContinue,
  lingerieUI,
} from "./stylesLoader";

import { getConfig, getQueryParam } from "./configLoader";
import { applyFontFromConfig } from "./fontLoader";

const config = getConfig();

export {
  uxGender,
  uxRoute,
  uxRouteQuestionOnly,
  uxRouteQuestionPushScan,
  uxRouteNone,
  uxRouteDefault,
  uxConsentScreen,
  uxHideConsentTitle,
  uxFitFeedbacks,
  uxForceDesktopLayout,
  font,
  titleStyles,
  subtitlesStyles,
  ctaStyles,
  policityStyles,
  scanCTAStyle,
  welcomeScreenUI,
  unitsRight,
  unitsFontFamily,
  unitsInactiveFontWeight,
  inputDesktopWidthOffset,
  choiceScreenUI,
  bodyScanScreenUI,
  femaleBraScreenUI,
  morphoUIStyles,
  resultScreenUI,
  activeStylesContinue,
  disabledStylesContinue,
  lingerieUI,
  config,
  getConfig,
  getQueryParam,
  applyFontFromConfig,
};
